import React from 'react';
import Link from 'gatsby-link';
import {
  faTwitterSquare,
  faGithubSquare,
  faTelegram,
  faLinkedin,
  faStackOverflow,
  faMastodon,
} from '@fortawesome/free-brands-svg-icons';
import { faRssSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { rhythm, options } from '../utils/typography';

const Container = (props) => (
  <div
    {...props}
    style={{
      marginTop: rhythm(0.25),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
    }}
  />
);

const Follow = (props) => (
  <div
    {...props}
    style={{
      marginTop: rhythm(0.5),
      marginLeft: rhythm(0.5),
      display: 'flex',
      justifyContent: 'space-between',
    }}
  />
);

const A = (props) => (
  <a
    {...props}
    style={{
      boxShadow: 'none',
      marginRight: rhythm(0.5),
    }}
  />
);

const NavItem = (props) => (
  <span
    {...props}
    style={{
      fontFamily: ['Montserrat', 'sans-serif'],
      fontWeight: 900,
      marginLeft: rhythm(0.1),
      marginRight: rhythm(0.1),
      fontSize: rhythm(0.95),
      marginTop: rhythm(0.25),
      marginBottom: 0,
    }}
  />
);

const NavLink = (props) => (
  <Link
    {...props}
    exact
    activeStyle={{
      pointerEvents: 'none',
      cursor: 'default',
      boxShadow: '0 1px 0 0 currentColor',
    }}
    style={{
      marginRight: rhythm(0.5),
    }}
  />
);

export default () => (
  <nav>
    <Container>
      <Container>
        <NavItem>
          <NavLink to="/">Blog</NavLink>
        </NavItem>
      </Container>
      <Follow>
        <A title="RSS" href="/rss.xml">
          <FontAwesomeIcon icon={faRssSquare} size="2x" />
        </A>
        <A title="GitHub" href="https://github.com/maxdesiatov">
          <FontAwesomeIcon icon={faGithubSquare} size="2x" />
        </A>
        <A rel="me" title="Mastodon" href="https://mastodon.social/@maxd">
          <FontAwesomeIcon icon={faMastodon} size="2x" />
        </A>
        {/* <A
        title="StackOverflow"
        href="https://stackoverflow.com/users/442427/max-desiatov"
      >
        <FontAwesomeIcon icon={faStackOverflow} size="2x" />
      </A> */}
      </Follow>
    </Container>
  </nav>
);



// WEBPACK FOOTER //
// ./src/components/Navigation.js